/**
 * Mocks are **opt-in**: `VITE_USE_MOCKS=true` and nothing else turns them on.
 *
 * PR6 had this the other way round, because there was no API to talk to. Now
 * there is, and a default-on mock layer is the kind of thing that ships to
 * production and answers every request with fixture data while looking
 * perfectly healthy. Unset means "talk to the real API".
 */
export const mocksEnabled = import.meta.env.VITE_USE_MOCKS === 'true';

/**
 * MSW and the handlers are behind a dynamic import so they land in their own
 * chunk and are never fetched when mocks are disabled — the production bundle
 * should not carry a mock server around.
 */
export async function startMocks() {
  if (!mocksEnabled) return;
  const [{ setupWorker }, { handlers }] = await Promise.all([
    import('msw/browser'),
    import('./handlers'),
  ]);
  const worker = setupWorker(...handlers);
  await worker.start({
    onUnhandledRequest: 'bypass',
    serviceWorker: { url: `${import.meta.env.BASE_URL}mockServiceWorker.js` },
  });
}
